import React, { useEffect, useRef, useState } from "react";
import {
  getAxiosResponse,
  postAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import Header from "../../../components/global/Header";
import { transformBlankToNull } from "../../../services/Util";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, Link } from "react-router-dom";
import Select from "react-select";
import $ from "jquery";
import { unstable_createChainedFunction } from "@mui/utils";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { useSelector } from "react-redux";
import Constants from "../../../Constants";
import { DownArrowIconWorkflow, EditPenIconReviewWorkflow, RecycleIconRequestRevision, RightArrowRequestRevision } from "../../../AppIcons";
import { ConditionalBlock } from "../../../ConditionalBlock";
export default function CreateReviewWorkflow() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const param = useParams();
  const [steps, setSteps] = useState([]);
  const [workflow, setWorkflow] = useState([]);
  const [newWorkFlowName, setNewWorkFlowName] = useState("");
  const [newWorkFlowDescription, setNewWorkFlowDescription] = useState("");
  const [defautSelectedDeparts, setDefaultSelectedDeparts] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [options, setOptions] = useState("");
  const [editablePhaseId, setEditablePhaseId] = useState("");
  const [showEditDuartion, setShowEditDuartion] = useState("");
  const [showEditAssignee, setShowEditAssignee] = useState("");
  const [showEditMultiAssignee, setShowEditMultiAssignee] = useState("");
  const [showEditReviewApprove, setShowEditReviewApprove] = useState("");
  const [showEditPermissions, setShowEditPermissions] = useState("");
  const [showEditRemovePhase, setShowEditRemovePhase] = useState("");
  const [showPhaseOnRemoval, setShowPhaseOnRemoval] = useState("");
  const [newPhaseDuration, setNewPhaseDuration] = useState("");
  const [showEditIcon, setShowEditIcon] = useState(true);
  const [validationErrors, setvalidationErrors] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState({
    label: "",
    value: "",
  });

  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;

  const toggleEditDuration = (e, stepIndex, phaseIndex) => {
    if (e.type==="click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
      setShowEditMultiAssignee(''); setShowEditAssignee('');setShowEditReviewApprove('');setShowEditPermissions('');
      setShowEditRemovePhase('');setShowPhaseOnRemoval('');
      `step${stepIndex}phase${phaseIndex}` === showEditDuartion
        ? setShowEditDuartion("")
        : setShowEditDuartion(`step${stepIndex}phase${phaseIndex}`); 
    }
  };
  const toggleAssignee = (e, stepIndex, phaseIndex) => {
    if (e.key === Constants.ENTER || e.type === "click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
      $(e.target).attr('aria-expanded', function(index, attrValue) {
        return attrValue === 'true' ? 'false' : 'true';
      });
      setShowEditMultiAssignee(''); setShowEditReviewApprove('');setShowEditPermissions('');
      setShowEditRemovePhase('');setShowPhaseOnRemoval('');setShowEditDuartion("");
  
      `step${stepIndex}phase${phaseIndex}` === showEditAssignee
        ? setShowEditAssignee("")
        : setShowEditAssignee(`step${stepIndex}phase${phaseIndex}`);
    }
  };
  const toggleAssigneeMulti = (e,stepIndex, phaseIndex) => {
    if(e.type === 'click' || (e.type === 'keydown' && e.key === Constants.ENTER) || ($('.popover-body.show').length && e.key === Constants.ESCAPE)){
      setShowEditAssignee(''); setShowEditReviewApprove('');setShowEditPermissions('');
      setShowEditRemovePhase('');setShowPhaseOnRemoval('');setShowEditDuartion("");

      `step${stepIndex}phase${phaseIndex}` === showEditMultiAssignee
        ? setShowEditMultiAssignee("")
        : setShowEditMultiAssignee(`step${stepIndex}phase${phaseIndex}`);
    }
  };
  const toggleReviewApprove = (e, stepIndex, phaseIndex) => {
    if (e.key===Constants.ENTER || e.type==="click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
      setShowEditAssignee(''); setShowEditMultiAssignee('');setShowEditPermissions('');
      setShowEditRemovePhase('');setShowPhaseOnRemoval('');setShowEditDuartion("");
      `step${stepIndex}phase${phaseIndex}` === showEditReviewApprove
        ? setShowEditReviewApprove("")
        : setShowEditReviewApprove(`step${stepIndex}phase${phaseIndex}`);
    }
  };
  const togglePermission = (e,stepIndex, phaseIndex) => {
    if(e.type === 'click' || (e.type === 'keydown' && e.key === Constants.ENTER) || ($('.popover-body.show').length && e.key === Constants.ESCAPE)){
    setShowEditAssignee(''); setShowEditMultiAssignee('');setShowEditReviewApprove("");
    setShowEditRemovePhase('');setShowPhaseOnRemoval('');setShowEditDuartion("");
    `step${stepIndex}phase${phaseIndex}` === showEditPermissions
      ? setShowEditPermissions("")
      : setShowEditPermissions(`step${stepIndex}phase${phaseIndex}`);
    }
  };
  const toggleEditRemovePhase = (e, stepIndex, phaseIndex) => {
    if (e.key === Constants.ENTER || e.type === "click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
      $(e.target).attr('aria-expanded', function(index, attrValue) {
        return attrValue === 'true' ? 'false' : 'true';
      });
      setShowEditAssignee(''); setShowEditMultiAssignee('');setShowEditReviewApprove("");
      setShowEditPermissions("");setShowPhaseOnRemoval('');setShowEditDuartion("");
      `step${stepIndex}phase${phaseIndex}` === showEditRemovePhase
        ? setShowEditRemovePhase("")
        : setShowEditRemovePhase(`step${stepIndex}phase${phaseIndex}`);
    }
  };
  const togglePhaseOnRejection = (e,stepIndex, phaseIndex) => {
    if (e.key === Constants.ENTER || e.type === "click" || ($('.popover-body.show').length && e.key === Constants.ESCAPE)) {
    setvalidationErrors('')
    setShowEditAssignee(''); setShowEditMultiAssignee('');setShowEditReviewApprove("");
    setShowEditPermissions("");setShowEditRemovePhase("");setShowEditDuartion("");
    `step${stepIndex}phase${phaseIndex}` === showPhaseOnRemoval
      ? setShowPhaseOnRemoval("")
      : setShowPhaseOnRemoval(`step${stepIndex}phase${phaseIndex}`);
    }  
  };
  const showTextBox = (prop) => {
    setvalidationErrors('')
    if (`step${prop.stepIndex}phase${prop.phaseIndex}` === editablePhaseId) {
      setShowEditIcon(true);
      setEditablePhaseId("");
    } else {
      setEditablePhaseId(`step${prop.stepIndex}phase${prop.phaseIndex}`);
    }
    setShowEditRemovePhase("");
  };
  const setAutomaticSync = (e) => {};
  
  const selectAssignee = (e, phaseIndex, stepIndex) => {
    setvalidationErrors('')
    var selectedAssignee = {};
    var value = ''
    if(e.type === "keydown" && e.key === Constants.ENTER){
      value = e.target.htmlFor
    }else if(e.type === 'change') {
      value = e.target.value
    }
    else{
      return ;
    }
    var copySteps = steps;
    if (value === "internal") {
      selectedAssignee = { code: "customer_user", display: "Internal",type:"CUSTOMER_USER" };
    } else{
      selectedAssignee = { code: "vendor", display: "Vendor",type:"VENDOR" };
      copySteps[stepIndex].phases[phaseIndex].allowMultiAssignee = false;
    }
    copySteps[stepIndex].phases[phaseIndex].assigneeType = selectedAssignee;
    setSteps(copySteps);
    setShowEditAssignee("");
    $(`#assignee_step${stepIndex}phase${phaseIndex}`).focus()
  };
  const changeStepName = (value, stepIndex) => {
    var copySteps = [...steps];
    copySteps[stepIndex].name = value;
    setSteps(copySteps);
  };
  const changePhaseName = (value, stepIndex, phaseIndex) => {
    setvalidationErrors('')
    var copySteps = [...steps];
    copySteps[stepIndex].phases[phaseIndex].name = value;
    setSteps(copySteps);
  };
  function isNumber(n) { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); } 
  const saveDuration = (stepIndex, phaseIndex) => {
    setvalidationErrors('')
    if(isNumber(newPhaseDuration)){
      var copySteps = [...steps];
      copySteps[stepIndex].phases[phaseIndex].durationInDays = newPhaseDuration;
      setSteps(copySteps);
      setShowEditDuartion("");
    }
  };
  const selectPermission = (e,selectedValue, prop) => {
    setvalidationErrors('')
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change' ){
      value = selectedValue
    }else if(($('.popover-body.show').length && e.key === Constants.ESCAPE)){
      setShowEditPermissions("");
      return ;
    }
    else{
      return;
    }
    var copyStep = [...steps];
    if (value) {
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = true;
    }
    else{
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = false;
    }
    setSteps(copyStep);
     setShowEditPermissions("");
     $(`#permission${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const selectPhaseType = (e,selectedValue, prop) => {
    setvalidationErrors('')
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change'){
      value = selectedValue
    }
    else{
      return ;
    }
    var copyStep = [...steps];
    if (value) {
      copyStep[prop.stepIndex].phases[prop.phaseIndex].isApprovalPhase = true;
      getReturnPhases(prop.step, prop.stepIndex, prop.phase, prop.phaseIndex);
    }else{
      copyStep[prop.stepIndex].phases[prop.phaseIndex].isApprovalPhase = false;
    }
    setSteps(copyStep);
    setShowEditReviewApprove("");
    $(`#review${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const selectMultiAssignee = (e,selectedValue, prop) => {
    setvalidationErrors('')
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change' || e.key=== "click"){
      value = selectedValue
    }
    else{
      return ;
    }
    var copyStep = [...steps];
    if (value) {
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowMultiAssignee = true;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = false;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].reviewmode_editable = false;
    }
    else{
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowMultiAssignee = false;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].allowRevision = true;
      copyStep[prop.stepIndex].phases[prop.phaseIndex].reviewmode_editable = true;
    }
    setSteps(copyStep);
    setShowEditMultiAssignee("");
    $(`#step${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  const selectReturnPhase = (e,selectedValue, prop) => {
    setvalidationErrors('')
    var value = ''
    if((e.type === "keydown" && e.key === Constants.ENTER) || e.type === 'change'){
      value = selectedValue
    }
    else{
      return ;
    }
    var copySteps = [...steps];
    var filterdDisplay = prop.phase.returnPhases.filter((returns) => {
      return Number(returns.phaseNumber) === Number(value);
    });
    copySteps[prop.stepIndex].phases[prop.phaseIndex].returnPhaseNumber = value;
    copySteps[prop.stepIndex].phases[prop.phaseIndex].returnPhaseDisplay =
      filterdDisplay[0].displayText;
    setSteps(copySteps);
    setShowPhaseOnRemoval("");
    $(`#return${prop.stepIndex}phase${prop.phaseIndex}`).focus()
  };
  

const handleClickOutside = (event) => {
    const list = event.target.classList.contains("workflow-wrap");
    const list1 = event.target.classList.contains("setting-review-flow")
    const list2 = event.target.classList.contains("flex-align-center");
    const box = event.target.classList.contains("step-box-list");
    const button = event.target.classList.contains("workflow-step-content")
    const paperroot = event.target.classList.contains("popup-padding")
    const create_workflow = event.target.classList.contains('create-new-review-workflow')
    // const svgItem = event.target.closest('.MuiSvgIcon-root');
    const dashboard = event.target.classList.contains("flex")
    if (list || list1 || list2  || box || dashboard || button || paperroot || create_workflow) {
      setShowEditAssignee(''); setShowEditMultiAssignee('');setShowEditReviewApprove("");
    setShowEditPermissions("");setShowEditRemovePhase("");setShowEditDuartion("");setShowPhaseOnRemoval("");
    }
};
document.addEventListener("click", handleClickOutside, true);
 
  const EditAssigneeComponent = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={"internal"}
                checked={
                  prop.defaultSelectedPhase.assigneeType?.code ===
                  "customer_user"
                }
                id="internal"
                onChange={(e) => {selectAssignee(e,prop.phaseIndex,prop.defaultSelectedStepIndex)}}
              />
              <label className="form-check-label" htmlFor="internal" tabIndex={0} 
              onKeyDown={(e) => {selectAssignee(e,prop.phaseIndex,prop.defaultSelectedStepIndex);}}>
                Internal
              </label>
            </div>
            <div className="radio-form-check">
              <input
              tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={"vendor"}
                checked={
                  prop.defaultSelectedPhase.assigneeType?.code === "vendor"
                }
                id="vendor"
                onChange={(e) => {
                  selectAssignee(
                    e,
                    prop.phaseIndex,
                    prop.defaultSelectedStepIndex
                  );
                }}
              />
              <label className="form-check-label" htmlFor="vendor" tabIndex={0} onKeyDown={(e) => {
                  selectAssignee(
                    e,
                    prop.phaseIndex,
                    prop.defaultSelectedStepIndex
                  );
                }}>
                Vendor
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const EditMultiAssignee = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show multi"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={false}
                checked={prop.phase.allowMultiAssignee === false}
                id={"single"}
                onChange={(e) => {selectMultiAssignee(e,false, prop)}}
              />
              <label className="form-check-label" tabIndex={0} htmlFor={"single"} 
              onKeyDown={(e) => {selectMultiAssignee(e,false, prop)}}>
                Single Assignee
              </label>
            </div>
            <div className="radio-form-check">
              <input
                type="radio"
                tabIndex={-1}
                className="form-check-input"
                value={true}
                checked={prop.phase.allowMultiAssignee === true}
                id={"multi"}
                onChange={(e) => {
                  selectMultiAssignee(e,true, prop);
                }}
              />
              <label className="form-check-label" tabIndex={0} htmlFor={"multi"} 
              onKeyDown={(e) => {selectMultiAssignee(e,true, prop)}}>
                Multiple Assignees and Timed Phases
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const EditReviewApprove = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                tabIndex={-1}
                type="radio"
                className="form-check-input"
                value={false}
                checked={prop.phase.isApprovalPhase === false}
                id={"internal"}
                onChange={(e) => {
                  selectPhaseType(e,false,prop);
                }}
              />
              <label className="form-check-label" htmlFor={"internal"} tabIndex={0} onKeyDown={(e)=>selectPhaseType(e,false, prop)}>
                Review
              </label>
            </div>
            {prop.phase.phaseNumber > 2 ? (
              <div className="radio-form-check">
                <input
                  type="radio"
                  tabIndex={-1}
                  className="form-check-input"
                  value={true}
                  checked={prop.phase.isApprovalPhase === true}
                  id={"vendor"}
                  onChange={(e) => {
                    selectPhaseType(e,true, prop);
                  }}
                />
                <label className="form-check-label" tabIndex={0} htmlFor={"vendor"} onKeyDown={(e)=>selectPhaseType(e,true, prop)}>
                  Approval
                </label>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };
  const EditPermission = (prop) => {
    return (
      <div className="popover-body show">
        <div className="inner-popover">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <input
                type="radio"
                tabIndex={-1}
                className="form-check-input"
                value={true}
                checked={
                  prop.phase.isApprovalPhase === true ||
                  prop.phase.allowRevision === true
                }
                id={"internal"}
                onChange={(e) => {selectPermission(e,true,prop);}}
              />
              <label className="form-check-label" htmlFor={"internal"} tabIndex={0} 
               onKeyDown={(e) => {selectPermission(e,true,prop)}}
              >
                Can Request Revision
              </label>
            </div>
            <div className="radio-form-check">
              <input
                type="radio"
                tabIndex={-1}
                className="form-check-input"
                value={false}
                checked={prop.phase.allowRevision === false}
                id={"vendor"}
                onChange={(e) => {selectPermission(e,false, prop)}}
              />
              <label className="form-check-label" htmlFor={"vendor"} tabIndex={0} 
               onKeyDown={(e) => {selectPermission(e,false,prop)}}
              >
                Cannot Request Revision
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const EditRemovePhase = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show"
      >
        <div className="inner-popover w-160">
          <div className="group-radio-list">
            <div className="radio-form-check">
              <Link onClick={() => showTextBox(prop)}>Edit Name</Link>
            </div>

            {steps[prop.stepIndex].phases.length > 2 ? (
              <div className="radio-form-check">
                <Link onClick={() => removePhase(prop)}>Remove Phase</Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  };
  const EditPhaseOnRejection = (prop) => {
    return (
      <div
        //ref={ref}
        className="popover-body show"
      >
        <div className="inner-popover">
          <div className="group-radio-list">
            {prop.phase.returnPhases.map((returnPhase, i) => {
              return (
                <div className="radio-form-check" key={i}>
                  <input
                    type="radio"
                    tabIndex={-1}
                    className="form-check-input"
                    value={returnPhase.phaseNumber}
                    checked={
                      Number(prop.phase.returnPhaseNumber) ===
                      Number(returnPhase.phaseNumber)
                    }
                    id={returnPhase.phaseNumber}
                    onChange={(e) => {selectReturnPhase(e,returnPhase.phaseNumber,prop)}}
                  />
                  <label
                    tabIndex={0}
                    onKeyDown={(e) => {selectReturnPhase(e,returnPhase.phaseNumber,prop)}}
                    className="form-check-label"
                    htmlFor={returnPhase.phaseNumber}
                    dangerouslySetInnerHTML={{
                      __html: returnPhase.displayText,
                    }}
                  ></label>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  const selectDepartments = (value) => {
    setvalidationErrors('')
    if (value.value === "all") {
      departments.map((depart) => {
        if(depart.value !== "all"){
          setDefaultSelectedDeparts((current) => [...current, depart.value]);
        }
      });
      setDepartments([]);
    } else {
      if(departments.length === 3){
        var remainDepart = departments.filter((depart) => depart.value !== 'all')
        setDepartments(remainDepart)
      }
      setDefaultSelectedDeparts((current) => [...current, value.value]);
      setDepartments((current) =>
        current.filter((depart) => depart.value.id !== value.value.id)
      );
    }
    setSelectedDepartment(value.value);
    $('body').removeClass('static-footer-btn');
  };
  const removeDepartment = (value) => {
    var departs = [...departments]
    setvalidationErrors('')
     setSelectedDepartment({label:'',value:''})
    setDefaultSelectedDeparts((current) =>
      current.filter((depart) => depart.id !== value.id)
    );
    if (value !== "all") {
      departs.push({ label: value.name, value: value })
      const strAscending = [...departs].sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1 ,
      );
      const isFound = departments.some(element => {
        if (element.value === 'all') {
          return true;
        }
        return false;
      });
      
      if (departments.length > 1 && !isFound) {
        strAscending.unshift({ label: "Select - All", value: "all" });
      }else{
        const fromIndex = strAscending.findIndex(object => {
          return object.value === 'all';
        });
          const toIndex = 0;
          const element = strAscending.splice(fromIndex, 1)[0];
          strAscending.splice(toIndex, 0, element);
      }
      setDepartments(strAscending);
    }
    const selectedElement = $(document.activeElement).closest("div");
    if($(document.activeElement).is(':last-child') &&
    selectedElement.children().length > 1){
      selectedElement.find('button').eq(-2).trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".department-block").find('.global-dropdown-select input').trigger('focus');
    }
  };
   $(document).on("click",".cw__control",function() {
    if ($('div').hasClass('cw__menu')){
      $('body').addClass('static-footer-btn');
    }
    else{
      $('body').removeClass('static-footer-btn');
    }
  });
  $(document).mouseup(function(e) {
    var selectShow = $('.global-dropdown-select');
    if (!selectShow.is(e.target) && selectShow.has(e.target).length === 0) {
      $('body').removeClass('static-footer-btn');
    }
});
  const getAllDepartments = () => {
    getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select - All", value: "all" }];
          res.data.data.map((depart) => {
            options.push({
              label: depart.name,
              value: depart,
            });
          });
          setDepartments(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  useEffect(() => {
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data.data);
    });
    addDefaultStep();
    getAllDepartments();
    var defaultWorkFlowStructure = {
      enableRating: false,
      steps: [],
    };
    setWorkflow(defaultWorkFlowStructure);
    $('.lastdisable').trigger('focus');
  }, []);

  const isFullWorkflowEditEnabled = () => {
    return options?.features?.CUSTOM_WORKFLOW;
  };
  const getReturnPhases = (step, stepIndex, phase, phaseIndex) => {
    var copySteps = [...steps];
    copySteps[stepIndex].phases[phaseIndex].returnPhases = [];
    step.phases.map((previousePhase, index) => {
      if (previousePhase.phaseNumber < phase.phaseNumber) {
        var returnPhase = {
          phaseNumber: previousePhase.phaseNumber,
        };
        if (phase.name && phase.name !== "") {
          returnPhase.name = previousePhase.name;
        } else {
          returnPhase.name = previousePhase.phaseType.display;
        }
       
        returnPhase.displayText =
          "Phase " +
          returnPhase.phaseNumber +
          "&nbsp;(" +
          returnPhase.name +
          ")";

        if (
          phase.returnPhaseNumber &&
          phase.returnPhaseNumber === returnPhase.phaseNumber
        ) {
          copySteps[stepIndex].phases[phaseIndex].returnPhaseDisplay =
            returnPhase.displayText;
        }
        copySteps[stepIndex].phases[phaseIndex].returnPhases.push(returnPhase);
      }
      setSteps(copySteps);
    });
  };
  const reviewModeEditable = (phase, step, index) => {
    var val =
      phase.phaseNumber !== 1 &&
      index + 1 < step.phases.length &&
      phase.isApprovalPhase !== true
        ? true
        : false;

    if (phase.allowMultiAssignee === true) {
      val = false;
    }
    return val;
  };
  const multiAssigneeEditable = (step, phase, index) => {
    if (
      (step.stepNumber !== 1 || phase.phaseNumber !== 1) &&
      phase.assigneeType &&
      phase.assigneeType.code === "customer_user" &&
      phase.phaseNumber !== 1 &&
      index + 1 < step.phases.length
    ) {
      return true;
    } else {
      return false;
    }
  };
  const removePhase = (prop) => {
    setvalidationErrors('')
    var copySteps = [...steps];
    var newPhases = [];
    var remainingReturnPhases = [];

    var remainingPhases = copySteps[prop.stepIndex].phases.filter((phase) => {
      return phase.phaseNumber !== prop.phase.phaseNumber;
    });

    remainingPhases.map((phase, index) => {
      phase.phaseNumber = index + 1;
      if (
        phase.returnPhaseNumber &&
        Number(phase.returnPhaseNumber) === Number(prop.phase.phaseNumber)
      ) {
        phase.returnPhaseNumber = "";
        if (phase.returnPhases.length !== 0) {
          remainingReturnPhases = phase.returnPhases.filter((returnPhase) => {
            return returnPhase.phaseNumber !== prop.phase.phaseNumber;
          });
        }
        phase.returnPhases = remainingReturnPhases;
      }
      newPhases.push(phase);
    });
    copySteps[prop.stepIndex].phases = newPhases;
    // var copyStep = [...steps]
    // delete copyStep[prop.stepIndex].phases[prop.phaseIndex]
    setSteps(copySteps);
  };
  const removeStep = (stepIndex, stepNumber) => {
    setvalidationErrors('')
    var copySteps = [...steps];
    var remainingSteps = [];
    var orderedSteps = [];
    remainingSteps = copySteps.filter((step) => {
      return step.stepNumber !== stepNumber;
    });
    remainingSteps.map((step, index) => {
      step.stepNumber = index + 1;
      step.name = `Step ${index + 1}`;
      orderedSteps.push(step);
    });
    setSteps(orderedSteps);
    setTimeout(() => {
      $('.add-workflow-btn.medium-workflow-btn').last().trigger('focus');
    }, 500);
  };
  const addStep = () => {
    setvalidationErrors('')
    var stepsLength = steps.length;
    var newStep = {
      stepNumber: stepsLength + 1,
      name: ``,
      placeHolder: `Step ${stepsLength + 1}`,
      phases: [
        {
          phaseNumber: 1,
          assigneeType: '',
          allowRevision: false,
          phaseType: {
            code: "work",
            display: "Work",
            type: "WORK",
          },
          assignee_editable: false,
          duration_editable: false,
          multi_assignee_editable: false,
          reviewmode_editable: false,
          durationTitleText: "Duration of work",
          allowMultiAssignee: false,
          timed: false,
          defaultName: "Work",
          returnPhases: [],
        },
        {
          phaseNumber: 2,
          returnPhases: [
            {
              phaseNumber: 1,
              name: "Work",
              displayText: "Phase 1&nbsp;(Work)",
            },
          ],
          assigneeType: '',
          phaseType: {
            code: "review",
            display: "Review",
            type: "REVIEW",
          },
          assignee_editable: true,
          duration_editable: true,
          multi_assignee_editable: false,
          reviewmode_editable: false,
          durationTitleText: "Duration of review",
          allowRevision: true,
          allowMultiAssignee: false,
          timed: false,
          defaultName: "Final Review",
          durationInDays: "",
          isApprovalPhase: false,
        },
      ],
      removable: true,
      name_editable: true,
    };
    var copySteps = [...steps];
    copySteps.push(newStep);
    setSteps(copySteps);
  };
  const addPhase = (stepIndex) => {
    setvalidationErrors('')
    var copySteps = [...steps];
    var returnPhases = [];
    copySteps[stepIndex].phases.map((phase) => {
      returnPhases.push({
        phaseNumber: phase.phaseNumber,
        name: phase.phaseType.display,
        displayText: `Phase ${phase.phaseNumber}&nbsp;(${phase.phaseType.display})`,
      });
    });
    var newPhase = {
      phaseNumber: copySteps[stepIndex].phases.length + 1,
      assigneeType: null,
      phaseType: { display: "Review", code: "review" },
      allowMultiAssignee: false,
      allowRevision: true,
      returnPhases: returnPhases,
      timed: false,
      assignee_editable: true,
      defaultName: "Final Review",
      durationTitleText: "Duration of review",
      duration_editable: true,
      multi_assignee_editable: false,
      reviewmode_editable: false,
    };
    copySteps[stepIndex].phases.push(newPhase);
    setSteps(copySteps);
  };
  const addDefaultStep = () => {
    var newStep = {
      stepNumber: 1,
      name: "Initial Translation",
      placeHolder: "",
      phases: [
        {
          phaseNumber: 1,
          assigneeType: {
            display: "Vendor",
            code: "vendor",
            type:"VENDOR"
          },
          allowRevision: false,
          phaseType: {
            code: "work",
            display: "Work",
            type: "WORK",
          },
          assignee_editable: false,
          duration_editable: false,
          multi_assignee_editable: false,
          reviewmode_editable: false,
          durationTitleText: "Duration of work",
          allowMultiAssignee: false,
          timed: false,
          defaultName: "Work",
          returnPhases: [],
        },
        {
          phaseNumber: 2,
          returnPhases: [
            {
              phaseNumber: 1,
              name: "Work",
              displayText: "Phase 1&nbsp;(Work)",
            },
          ],
          assigneeType: { code: "customer_user", display: "Internal",type:"CUSTOMER_USER" },
          phaseType: {
            code: "review",
            display: "Review",
            type: "REVIEW",
          },
          assignee_editable: true,
          duration_editable: true,
          multi_assignee_editable: false,
          reviewmode_editable: false,
          durationTitleText: "Duration of review",
          allowRevision: true,
          allowMultiAssignee: false,
          timed: false,
          defaultName: "Final Review",
          durationInDays: "",
          isApprovalPhase: false,
        },
      ],
      removable: false,
      name_editable: true,
    };

    var copySteps = [...steps];
    copySteps.push(newStep);
    setSteps(copySteps);
  };
  const saveWorkflow = () => {
    var copyworkflow = { ...workflow };
    copyworkflow.steps = steps;
    if (defautSelectedDeparts.length !== 0) {
      copyworkflow.userGroups = defautSelectedDeparts;
    }
    if (newWorkFlowName !== "") {
      copyworkflow.name = newWorkFlowName;
    }
    if (newWorkFlowDescription !== "") {
      copyworkflow.description = newWorkFlowDescription;
    }
    var payload = transformBlankToNull(copyworkflow);
    postAxiosResponse(APIUrls.CREATE_WORKFLOW, payload).then((res) => {
      if (res.data.data.body && res.data.data.body.success === false) {
        setvalidationErrors(res.data.data.body.errors);
      }
      else{
        navigate("/settings/review-workflow");
      }
      
    });
  };
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Review workflow template', url:'settings/review-workflow'},
    {label:'Add new template', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button
                    aria-label="back"
                    onClick={() => navigate("/settings/review-workflow")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8"
                      />
                    </svg>
                  </button>
                  <span>Return to Review Workflow Templates</span>
                </div>
                <h3 className="flex">Create New Review Workflow Template</h3>
                <span>Set up your workflow template.</span>
              </div>
              <div className="white-bg">
                <div className="create-new-review-workflow">
                  <div className="wrap-dropdown">
                  <div className="wrap-input-text-group mar-bot20 global-dropdown-block">
                    <label>Name {validationErrors.name ? (
                      <span style={{marginBottom:'4px',color:"#FFADAD"}}>{validationErrors.name}</span>
                    ) : null}</label>
                    <div className="input-text-group flex">
                      <input
                        type="text"
                        aria-required={true}
                        aria-label="name"
                        className="form-control-sm"
                        title="name"
                        maxLength={50}
                        defaultValue={workflow.name}
                        onChange={(e) => setNewWorkFlowName(e.target.value)}
                      />
                    </div>
                  </div>
                  </div>
                  
                  <div className="wrap-input-text-group mar-bot20">
                    <label>Description</label>
                    <div className="input-text-group flex">
                      <textarea
                        aria-label="description"
                        className="textarea max-680"
                        maxLength={255}
                        defaultValue={workflow.description}
                        onChange={(e) =>
                          setNewWorkFlowDescription(e.target.value)
                        }
                      ></textarea>
                    </div>
                    <div>{`${255 - newWorkFlowDescription.length}`} {255 - newWorkFlowDescription.length > 1 ? 'characters left' : 'character left'}</div>
                  </div>
                  <div className="project-heading">
                    <h6>Workflow Steps</h6>
                    <p>
                      Select the name, duration and assignee of each workflow
                      step in the template. Users creating projects will see
                      this configuration, and will be able to edit the due dates
                      and assignees to fit their project.
                    </p>
                    {validationErrors.steps ? <p className="error">{validationErrors.steps}</p> : ''}
                  </div>
                  <div className="workflow-wrap flex-align-center setting-review-flow">
                    {steps && steps?.length > 0 &&  steps.map((step, stepIndex) => {
                      return (
                        <React.Fragment key={stepIndex}>
                          <div className="workflow-step-list open-step flex">
                            <div className="inner-step-list">
                              <input
                                className="step-btn"
                                style={validationErrors['steps.' + stepIndex + '.name'] !== undefined ? {border:"2px solid #FFADAD "} : {}}
                                type="text"
                                maxLength={25}
                                aria-label="workflow step name"
                                defaultValue={
                                  step.name !== ""
                                    ? step.name
                                    : `Step ${step.stepNumber}`
                                }
                                onChange={(e) =>
                                  changeStepName(e.target.value, stepIndex)
                                }
                              />
                              <div className="workflow-step-content popup-padding flex">
                                {step.phases.map((phase, index) => {
                                  return (
                                    <div className="step-box-list" key={index}>
                                      {isFullWorkflowEditEnabled &&
                                      (step.stepNumber !== 1 ||
                                        phase.phaseNumber !== 1) ? (
                                        <div className="workflowName step-assignee">
                                          <button
                                            style={validationErrors['steps.' + stepIndex + '.phases.'+ index +'.durationInDays'] !== undefined ? {border:"2px solid #FFADAD "} : {}}
                                            className="step-cal flex-center "
                                            aria-label="Duration picker"
                                            aria-expanded={showEditDuartion === `step${stepIndex}phase${index}` ? true : false}
                                            onClick={(e) =>toggleEditDuration(e,stepIndex,index)}
                                            onKeyDown={(e) =>toggleEditDuration(e,stepIndex,index)
                                            }
                                          >
                                            {" "}
                                            {phase.durationInDays !== "" && phase.durationInDays !== undefined ? (
                                              <span>{phase.durationInDays} days</span>
                                            ) : (
                                              <span>Duration</span>
                                            )}
                                          </button>
                                          {showEditDuartion === `step${stepIndex}phase${index}` ? (
                                            <div
                                              id={phase.id}
                                              className="popover-body show"
                                            >
                                              <div className="inner-popover">
                                                <h4>Duration of review</h4>
                                                <div>
                                                  <div className="flex mar-bot10">
                                                  <input
                                                    type="text"
                                                    style={{width:"40%"}}
                                                    className="form-control-sm"
                                                    aria-label="enter duration in days"
                                                    maxLength="3"
                                                    onChange={(e) =>setNewPhaseDuration(parseInt(e.target.value))}
                                                    defaultValue={phase?.durationInDays}
                                                  ></input>{" "}
                                                  <div style={{padding:"5px 10px 10px"}}>Days</div>
                                                  </div>
                                                  

                                                  <div className="left flex btn-gap justify-end">
                                                    <div>
                                                      <button
                                                        className="blue-btn triggerBtn"
                                                        onClick={() => {setShowEditDuartion("");setNewPhaseDuration('')}}
                                                      >
                                                        Cancel
                                                      </button>
                                                    </div>
                                                    <div>
                                                      <button
                                                        className="blue-btn active"
                                                        onClick={() =>
                                                          saveDuration(
                                                            stepIndex,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                        </div>
                                      ) : phase.durationInDays !== "" && phase.durationInDays !== undefined ? (
                                        <span>{phase.durationInDay} days</span>
                                      ) : null}
                                      <div className="step-assignee flex-center thisAdd"
                                      aria-expanded={showEditRemovePhase === `step${stepIndex}phase${index}` ? true : false}
                                      tabIndex="0" role="button" 
                                        onClick={(e) => editablePhaseId === '' ? toggleEditRemovePhase(e,stepIndex,index) : null} 
                                        onKeyDown={(e) =>toggleEditRemovePhase(e,stepIndex,index)}>
                                        {editablePhaseId ===
                                        `step${stepIndex}phase${index}` ? (
                                          <input
                                            type="text"
                                            className="form-control-sm"
                                            maxLength={20}
                                            defaultValue={
                                              phase.name !== undefined &&
                                              phase.name !== ""
                                                ? phase.name
                                                : phase.phaseNumber ===
                                                  step.phases.length
                                                ? "Final Review"
                                                : phase?.phaseType?.display
                                            }
                                            onChange={(e) =>
                                              changePhaseName(
                                                e.target.value,
                                                stepIndex,
                                                index
                                              )
                                            }
                                            onBlur={() =>
                                              setEditablePhaseId("")
                                            }
                                          />
                                        ) : (
                                           <>
                                            {phase.name !== undefined &&
                                            phase.name !== "" ? (
                                              <span className="phaseName">
                                                {phase.name}
                                              </span>
                                            ) : phase.phaseNumber ===
                                              step.phases.length ? (
                                              <span className="finalPhaseName">
                                                Final Review
                                              </span>
                                            ) : (
                                              <span className="phaseDisplay">
                                                {phase.phaseType.display}
                                              </span>
                                            )}
                                          </>
                                        )}

                                        {isFullWorkflowEditEnabled ? (
                                          <>
                                            <button
                                              className="inline-flex"
                                              aria-label="edit"
                                              tabIndex="-1"
                                              onClick={()=>setEditablePhaseId("")}
                                            >
                                              {showEditIcon ? (
                                                EditPenIconReviewWorkflow
                                              ) : null}
                                            </button>
                                            {showEditRemovePhase ===
                                            `step${stepIndex}phase${index}` ? (
                                              <EditRemovePhase
                                                phaseIndex={index}
                                                stepIndex={stepIndex}
                                                phase={phase}
                                              />
                                            ) : null}
                                          </>
                                        ) : null}
                                      </div>
                                      {isFullWorkflowEditEnabled &&
                                      !(
                                        step.stepNumber === 1 &&
                                        phase.phaseNumber === 1
                                      ) ? (
                                        phase.assigneeType !== '' ? (
                                          <div className="step-assignee">
                                            <div className="step-assignee flex-center" role="button" 
                                            tabIndex="0"
                                            id={`assignee_step${stepIndex}phase${index}`}
                                            aria-expanded={showEditAssignee === `step${stepIndex}phase${index}` ? true : false}
                                            aria-label={phase.assigneeType !== undefined && phase.assigneeType !== null
                                              ? phase?.assigneeType?.display+' ,phase assignee'
                                              : "phase assignee"}
                                            style={validationErrors['steps.'+stepIndex+'.phases.'+index+'.assigneeType'] !== undefined ? {border:"2px solid #FFADAD ",padding:"0px 2px",borderRadius:"5px"} : {} }
                                            onClick={(e) => toggleAssignee(e, stepIndex, index)}
                                            onKeyDown={(e) =>toggleAssignee(e, stepIndex, index)}
                                          >
                                              <span className="select"><strong>
                                                {phase.assigneeType !== undefined && phase.assigneeType !== null
                                                  ? phase?.assigneeType?.display
                                                  : "Assignee"}
                                              </strong></span>
                                            
                                              <svg
                                                className="dropdown-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                  fill="#1D4ED8"
                                                ></path>
                                              </svg>
                                              </div>
                                            {showEditAssignee ===
                                            `step${stepIndex}phase${index}` ? (
                                              <EditAssigneeComponent
                                                defaultSelectedPhase={phase}
                                                phaseIndex={index}
                                                defaultSelectedStepIndex={
                                                  stepIndex
                                                }
                                              />
                                            ) : null}
                                          </div>
                                        ) : 
                                        <div className="step-assignee">
                                          <div className="step-assignee flex-center"
                                          style={validationErrors['steps.'+stepIndex+'.phases.'+index+'.assigneeType'] !== undefined ? {border:"2px solid #FFADAD ",padding:"0px 2px",borderRadius:"5px"} : {} }
                                           role="button"
                                           aria-label={phase.assigneeType !== undefined && phase.assigneeType !== null
                                            ? phase?.assigneeType?.display+' ,phase assignee'
                                            : "phase assignee"}
                                           id={`assignee_step${stepIndex}phase${index}`}
                                            onClick={(e) =>
                                          toggleAssignee(e,stepIndex, index)}
                                          onKeyDown={(e) =>
                                            toggleAssignee(e, stepIndex, index)}
                                        >
                                          <span><strong className="2">Assignee</strong></span>
                                          <svg
                                                className="dropdown-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                  fill="#1D4ED8"
                                                ></path>
                                              </svg>
                                              </div>
                                              {showEditAssignee ===
                                            `step${stepIndex}phase${index}` ? (
                                              <EditAssigneeComponent
                                                defaultSelectedPhase={phase}
                                                phaseIndex={index}
                                                defaultSelectedStepIndex={
                                                  stepIndex
                                                }
                                              />
                                            ) : null}
                                        </div>
                                        
                                      ) : phase.assigneeType !== "" && phase.assigneeType !== null ? (
                                        <strong className="3">
                                          {phase?.assigneeType?.display}
                                        </strong>
                                      ) : (
                                        <strong className="4">Assignee</strong>
                                      )}
                                      
                                      <div className="step-assignee">
                                        <div
                                        id={`step${stepIndex}phase${index}`}
                                        className="step-assignee flex-center justify-center"
                                          role="button"
                                          aria-label={phase.allowMultiAssignee ? "Multi Assignee" : "Single Assignee"}
                                          aria-expanded={showEditMultiAssignee ===
                                            `step${stepIndex}phase${index}` ? true : false}
                                          tabIndex={options?.features?.MULTI_ASSIGNEE_PHASE
                                            ? isFullWorkflowEditEnabled &&
                                              multiAssigneeEditable(step,phase,index)
                                              ? 0 : -1 : -1}
                                          onClick={(e) =>
                                            options?.features?.MULTI_ASSIGNEE_PHASE
                                              ? isFullWorkflowEditEnabled &&
                                                multiAssigneeEditable(
                                                  step,
                                                  phase,
                                                  index
                                                )
                                                ? toggleAssigneeMulti(e,stepIndex,index)
                                                : null
                                              : null
                                          }
                                          onKeyDown={(e) =>
                                            options?.features?.MULTI_ASSIGNEE_PHASE
                                              ? isFullWorkflowEditEnabled &&
                                                multiAssigneeEditable(step,phase,index)
                                                ? toggleAssigneeMulti(e,stepIndex,index)
                                                : null
                                              : null
                                          }
                                        >
                                           <div className="flex-center width-120">
                                           <span className="pl-0">
                                            {phase.allowMultiAssignee
                                              ? "Multi Assignee"
                                              : "Single Assignee"}
                                          </span>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="17"
                                            height="17"
                                            viewBox="0 0 17 17"
                                            fill="none"
                                          >
                                            <path
                                              d="M8.5 17C10.7704 17 12.905 16.1158 14.5104 14.5104C16.1158 12.905 17 10.7704 17 8.5C17 6.22957 16.1158 4.09504 14.5104 2.48957C12.905 0.884166 10.7704 0 8.5 0C6.22957 0 4.09504 0.884166 2.48957 2.48957C0.884167 4.09504 0 6.22957 0 8.5C0 10.7704 0.884167 12.905 2.48957 14.5104C4.09504 16.1158 6.22957 17 8.5 17ZM8.5 1.32812C12.4546 1.32812 15.6719 4.54541 15.6719 8.5C15.6719 12.4546 12.4546 15.6719 8.5 15.6719C4.54541 15.6719 1.32812 12.4546 1.32812 8.5C1.32812 4.54541 4.54541 1.32812 8.5 1.32812ZM8.5332 9.13086C10.2908 9.13086 11.7207 7.70097 11.7207 5.94336C11.7207 4.18575 10.2908 2.75586 8.5332 2.75586C6.7756 2.75586 5.3457 4.18575 5.3457 5.94336C5.3457 7.70097 6.7756 9.13086 8.5332 9.13086ZM8.5332 4.08398C9.55848 4.08398 10.3926 4.91811 10.3926 5.94336C10.3926 6.96861 9.55848 7.80273 8.5332 7.80273C7.50792 7.80273 6.67383 6.96861 6.67383 5.94336C6.67383 4.91811 7.50792 4.08398 8.5332 4.08398Z"
                                              fill="#1D4ED8"
                                            ></path>
                                            <path
                                              d="M4.74697 13.1484C4.93919 13.1484 5.12977 13.0654 5.26109 12.9052C5.9468 12.068 6.95976 11.5879 8.04026 11.5879H8.82817C9.90866 11.5879 10.9216 12.068 11.6073 12.9052C11.8397 13.1888 12.2581 13.2305 12.5418 12.9981C12.8256 12.7657 12.8672 12.3473 12.6348 12.0636C11.6958 10.9172 10.3083 10.2598 8.82817 10.2598H8.04026C6.5601 10.2598 5.17264 10.9172 4.23365 12.0636C4.00126 12.3473 4.04287 12.7657 4.32662 12.9981C4.45 13.0992 4.59895 13.1484 4.74697 13.1484Z"
                                              fill="#1D4ED8"
                                            ></path>
                                          </svg>
                                           </div>
                                          {options?.features
                                            ?.MULTI_ASSIGNEE_PHASE ? (
                                            isFullWorkflowEditEnabled &&
                                            multiAssigneeEditable(
                                              step,
                                              phase,
                                              index
                                            ) ? (
                                              <>
                                                <svg
                                                  className="dropdown-icon"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                  fill="none"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                    fill="#1D4ED8"
                                                  ></path>
                                                </svg>
                                              </>
                                            ) : null
                                          ) : null}
                                        </div>
                                        {showEditMultiAssignee ===
                                        `step${stepIndex}phase${index}` ? (
                                          <EditMultiAssignee
                                            phase={phase}
                                            step={step}
                                            phaseIndex={index}
                                            stepIndex={stepIndex}
                                          />
                                        ) : null}
                                      </div>
                                      {phase.phaseType?.code === "review" ? (
                                        <div className="step-assignee">
                                          <div className="step-assignee flex-center "
                                            role="button"
                                            id={`review${stepIndex}phase${index}`}
                                            tabIndex={0}
                                            aria-expanded={showEditReviewApprove ===
                                              `step${stepIndex}phase${index}` ? true : false}
                                            onClick={(e) =>
                                            toggleReviewApprove(
                                              e,
                                              stepIndex,
                                              index
                                            )}
                                            onKeyDown={(e) =>
                                              toggleReviewApprove(
                                                e,
                                                stepIndex,
                                                index
                                              )
                                            }
                                          >
                                          {phase.isApprovalPhase ? (
                                            <>
                                              <span>Approval</span>
                                              <svg
                                                className="dropdown-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                  fill="#1D4ED8"
                                                ></path>
                                              </svg></>
                                           
                                          ) : (
                                            <>
                                              <span>Review</span>
                                              <svg
                                                className="dropdown-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  clipRule="evenodd"
                                                  d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                  fill="#1D4ED8"
                                                ></path>
                                              </svg>
                                              </>
                                          )}
                                          </div>
                                          {showEditReviewApprove ===
                                          `step${stepIndex}phase${index}` ? (
                                            <EditReviewApprove
                                              phase={phase}
                                              step={step}
                                              phaseIndex={index}
                                              stepIndex={stepIndex}
                                            />
                                          ) : null}
                                        </div>
                                      ) : null}
                                      {phase.isApprovalPhase ? (
                                        <>
                                          <span>Phase on rejection :</span>
                                          <div className="step-assignee">
                                            <div className="step-assignee flex-center" 
                                            tabIndex={0}
                                            id={`return${stepIndex}phase${index}`}
                                            aria-expanded={showPhaseOnRemoval === `step${stepIndex}phase${index}` ? true : false}
                                            role="button"
                                            onKeyDown={(e) =>togglePhaseOnRejection(e,stepIndex,index)}
                                            onClick={(e) =>togglePhaseOnRejection(e,stepIndex,index)}>  
                                              <span
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    phase.returnPhaseDisplay
                                                      ? phase.returnPhaseDisplay
                                                      : phase.returnPhases[0]
                                                          .displayText,
                                                }}
                                              ></span>
                                              {DownArrowIconWorkflow}
                                            </div>
                                            {showPhaseOnRemoval ===
                                            `step${stepIndex}phase${index}` ? (
                                              <EditPhaseOnRejection
                                                phase={phase}
                                                step={step}
                                                phaseIndex={index}
                                                stepIndex={stepIndex}
                                              />
                                            ) : null}
                                          </div>
                                        </>
                                      ) : null}
                                      {isFullWorkflowEditEnabled &&
                                      reviewModeEditable(phase, step, index) &&
                                      phase.phaseType.display !==
                                        "Approval Only" ? 
                                        <div className="step-assignee ">
                                        <div className="step-assignee flex-center" 
                                        tabIndex={0}
                                        id={`permission${stepIndex}phase${index}`}
                                        role="button"
                                        aria-expanded={showEditPermissions === `step${stepIndex}phase${index}` ? true : false}
                                        onClick={(e) =>togglePermission(e,stepIndex, index)}
                                        onKeyDown={(e)=>togglePermission(e,stepIndex, index)}
                                        >
                                            <span>Permissions</span>
                                            <svg
                                              className="dropdown-icon"
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 16 16"
                                              fill="none"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4.5C8.5 4.36739 8.44732 4.24021 8.35355 4.14645C8.25979 4.05268 8.13261 4 8 4C7.86739 4 7.74021 4.05268 7.64645 4.14645C7.55268 4.24021 7.5 4.36739 7.5 4.5V10.293L5.354 8.146C5.26011 8.05211 5.13278 7.99937 5 7.99937C4.86722 7.99937 4.73989 8.05211 4.646 8.146C4.55211 8.23989 4.49937 8.36722 4.49937 8.5C4.49937 8.63278 4.55211 8.76011 4.646 8.854L7.646 11.854C7.69245 11.9006 7.74762 11.9375 7.80837 11.9627C7.86911 11.9879 7.93423 12.0009 8 12.0009C8.06577 12.0009 8.13089 11.9879 8.19163 11.9627C8.25238 11.9375 8.30755 11.9006 8.354 11.854L11.354 8.854C11.4479 8.76011 11.5006 8.63278 11.5006 8.5C11.5006 8.36722 11.4479 8.23989 11.354 8.146C11.2601 8.05211 11.1328 7.99937 11 7.99937C10.8672 7.99937 10.7399 8.05211 10.646 8.146L8.5 10.293V4.5Z"
                                                fill="#1D4ED8"
                                              ></path>
                                            </svg>
                                        </div>
                                        {showEditPermissions === `step${stepIndex}phase${index}` ? (
                                          <EditPermission
                                            phase={phase}
                                            step={step}
                                            phaseIndex={index}
                                            stepIndex={stepIndex}
                                          />
                                        ) : null}</div>
                                       : phase.phaseType.code === "review" ? (
                                        phase.allowRevision === true ? (
                                          <div className="step-request">
                                            <span className="revision-allowed pl-0">
                                              Can Request Revision
                                            </span>
                                            <div className="left-icon">
                                              {RecycleIconRequestRevision}
                                            </div>
                                            
                                          </div>
                                        ) : (
                                          <div className="step-request">
                                            <div className="left-icon">
                                              {RightArrowRequestRevision}
                                            </div>
                                            <span>Cannot Request Revision</span>
                                          </div>
                                        )
                                      ) : phase.phaseType.code === "work" ? (
                                        <div className="step-request">
                                          
                                          <div className="left-icon">
                                          {RightArrowRequestRevision}
                                          </div>
                                          <span>Can not Request Revision</span>
                                          </div>
                                      ) : null}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                           
                            {stepIndex !== 0 && isFullWorkflowEditEnabled ? (
                              <div className="workflow-remove-step">
                                <button
                                  
                                  onClick={() =>
                                    removeStep(stepIndex, step.stepNumber)
                                  }
                                >
                                  <svg
                                    className="minus-circle"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 26 26"
                                    fill="none"
                                  >
                                    <circle
                                      cx="13"
                                      cy="13"
                                      r="8"
                                      fill="#F9FBFF"
                                      stroke="#1D4ED8"
                                      strokeWidth="1.4"
                                    ></circle>
                                    <rect
                                      x="6.5"
                                      y="16"
                                      width="1.44444"
                                      height="8"
                                      rx="0.722222"
                                      transform="rotate(-90 6.5 13.7227)"
                                      fill="#1D4ED8"
                                    ></rect>
                                  </svg>{" "}
                                  Remove Step
                                </button>
                              </div>
                            ) : null}
                             <button
                            className="add-workflow-btn"
                            aria-label="add phase"
                            key={stepIndex}
                            onClick={() => addPhase(stepIndex)}
                          >
                            <svg
                              className="aaa-change-icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M0.28125 6.125H5.625V0.78125C5.625 0.626562 5.75156 0.5 5.90625 0.5H7.59375C7.74844 0.5 7.875 0.626562 7.875 0.78125V6.125H13.2188C13.3734 6.125 13.5 6.25156 13.5 6.40625V8.09375C13.5 8.24844 13.3734 8.375 13.2188 8.375H7.875V13.7188C7.875 13.8734 7.74844 14 7.59375 14H5.90625C5.75156 14 5.625 13.8734 5.625 13.7188V8.375H0.28125C0.126562 8.375 0 8.24844 0 8.09375V6.40625C0 6.25156 0.126562 6.125 0.28125 6.125Z"
                                fill="#1D4ED8"
                              />
                            </svg>
                          </button>
                        <ConditionalBlock condition={custBootstrapDataRedux?.workflowStepsLimit !==steps.length}>
                        <button
                      className="add-workflow-btn medium-workflow-btn"
                      aria-label="add step"
                      onClick={addStep}
                    >
                      <svg
                        className="aaa-change-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                      >
                        <path
                          d="M0.378233 8.40948H7.56465V1.22306C7.56465 1.01503 7.73486 0.844828 7.94289 0.844828H10.2123C10.4203 0.844828 10.5905 1.01503 10.5905 1.22306V8.40948H17.7769C17.985 8.40948 18.1552 8.57969 18.1552 8.78772V11.0571C18.1552 11.2651 17.985 11.4353 17.7769 11.4353H10.5905V18.6218C10.5905 18.8298 10.4203 19 10.2123 19H7.94289C7.73486 19 7.56465 18.8298 7.56465 18.6218V11.4353H0.378233C0.170205 11.4353 0 11.2651 0 11.0571V8.78772C0 8.57969 0.170205 8.40948 0.378233 8.40948Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                    </button>
                          </ConditionalBlock>
                          </div>
                         
                        </React.Fragment>
                      );
                    })}

                    
                  </div>
                  <div className="department-block mar-bot30">
                    <h6>Departments</h6>
                    <p>Which departments can use this workflow?</p>
                    <div className="flex wrap-dropdown mb-0">
                      <div className="global-dropdown-block">
                        <label>{validationErrors.userGroups ? <span style={{marginBottom:'4px',color:"#FFADAD "}}>{validationErrors.userGroups}</span> : ''}</label>
                        <Select
                          classNamePrefix="cw"
                          className="global-dropdown-select"
                          value={departments.filter(function (option) {
                            if(selectedDepartment.value !== ""){
                              return option.value.id === selectedDepartment?.id;
                            }
                          })}
                          placeholder={"Select Department"}
                          aria-label="Departments"
                          options={departments}
                          onChange={(e) => selectDepartments(e)}
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                        />
                      </div>
                    </div>
                   
                    <div className="multiselect-output flex">
                      <div>
                        {defautSelectedDeparts.map((depart, index) => {
                          return (
                            <button
                              key={index}
                              onClick={() => removeDepartment(depart)}
                              aria-label={'remove ' + depart.name}
                            >
                              <strong>{depart.name}</strong>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10"
                                height="9"
                                viewBox="0 0 10 9"
                                fill="none"
                              >
                                <path
                                  d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                  stroke="#213248"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="additional-option">
                    {options?.features?.AUTOMATIC_TM_SYNC === true ? (
                      <div className="form-check small-checkbox">
                        <h6>Additional Options</h6>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="checkbox"
                          id="chk2"
                          onChange={(e) => setAutomaticSync(e)}
                        />
                        <label className="form-check-label" htmlFor="chk2">
                          Automatic TM Sync
                        </label>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button className="btn-default" onClick={()=>navigate("/settings/review-workflow")}>Cancel</button>
          </div>
          
          <div>
            <button className="btn-default" onClick={saveWorkflow}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
